import { type ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useHasCompany } from './hooks/useHasCompany.ts';

/**
 * Gates areas that only make sense for students who belong to a company, such as
 * lessons and tutor-reviewed mark disputes — public self-signup students have no
 * company, and so no staff to serve them. Nest inside
 * RequireStudentOrTutorSession, which handles the signed-out and not-a-student
 * cases.
 */
export default function RequireCompanyStudent({ children }: { children: ReactElement }) {
  const hasCompany = useHasCompany();

  if (hasCompany === null) return null;

  return hasCompany ? children : <Navigate to="/practice" replace />;
}
